import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Star } from '../../assets/stars';
import LayoutContainer from '../LayoutContainer';
import RoundButton from '../RoundButton';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import './styles.css';

const SecondaryNav = ({ back }) => {
  const {
    modal: { showModal },
  } = useContext(Context);

  return (
    <div className="SecondaryNav__root">
      <LayoutContainer className="SecondaryNav__container" type="fullWidth">
        <div className="SecondaryNav__left">
          {back && (
            <div className="SecondaryNav__back">
              <Link to={back.url}>
                <i className="icon-generalcaretleftsmall" /> {back.label}
              </Link>
            </div>
          )}
        </div>
        <div className="SecondaryNav__right">
          <RoundButton
            icon={<Star width={15} height={15} stroke="var(--color-primary)" />}
            size="small"
            type="button"
            className="SecondaryNav__botton--review"
            onClick={() =>
              showModal(MODALS.REVIEW_FORM, {
                disableDefaults: true,
              })
            }
          >
            Write a Review
          </RoundButton>
          <div className="SecondaryNav__divider" />
          <RoundButton
            icon={<i className="icon-categorynewsagents" />}
            size="small"
            type="button"
            onClick={() => showModal(MODALS.ADD_A_BUSINESS)}
            className="SecondaryNav__botton--addABusiness"
          >
            Add a Business
          </RoundButton>
        </div>
      </LayoutContainer>
    </div>
  );
};

export default SecondaryNav;
